import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';
interface ICardBodyProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const CardBody: React.FunctionComponent<ICardBodyProps> = (props) => {
  return (
    <div className={C('card-body', props.className)} data-testid={props.testId}>
      {props.children}
    </div>
  );
};
